import { useQuery } from "@tanstack/react-query";
import { apiClient } from "~/services/api.service";
import {  endpointsPublic } from "~/services/endpoint";

export const useBlogDetail = (id: any) => {
  const params = {
    populate: 'image',
  }
 const { data, isPending, error, refetch } = useQuery({
    queryKey: [endpointsPublic.detail_blog, id],
    queryFn: () => {
      const url = `${endpointsPublic.detail_blog}/${id}`;
      return apiClient.get(url, params);
    },
    enabled: !!id,
  });

  return { data: data?.data, isPending, error, refetch };
};
